"use client";

import { Hero } from "@/components/site/Hero";
import { Logos } from "@/components/site/Logos";
import { Showcase } from "@/components/site/Showcase";
import { Features } from "@/components/site/Features";
import { VideoSection } from "@/components/site/VideoSection";
import { Gallery } from "@/components/site/Gallery";
import { SocialProof } from "@/components/site/SocialProof";
import { Pricing } from "@/components/site/Pricing";
import { Footer } from "@/components/site/Footer";

export default function Index() {
  return (
    <main className="bg-background text-foreground">
      <Hero />
      <Logos />
      <Showcase />
      <Features />
      <VideoSection />
      <Gallery />
      <SocialProof />
      <Pricing />
      <Footer />
    </main>
  );
}
